<template lang="pug">
.data-item
  .key {{ title }}
  .value {{ value }}
</template>

<script>
export default {
  props: {
    title: {
      default: '',
    },
    value: {
      default: '',
    },
  },
};
</script>

<style lang="scss">
.data-item {
  .key {
    font-size: 15px;
    opacity: 0.5;
    letter-spacing: 1px;
  }
  .value {
    font-size: 17px;
    color: #6B6C6F;
    &.red {
      color: #E11A1A;
      font-weight: 500;
    }
  }
}
</style>
